import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";

import UiContextProvider from "./contexts/UiContextProvider";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faTrash,
  faEdit,
  faUniversity,
  faUserFriends,
  faFileInvoice,
  faCar,
  faHome,
  faList,
  faListAlt,
  faClipboardList,
  faSearch,
  faCalendarAlt,
  faMinus,
  faPlus,
  faWrench,
  faBook,
  faTimesCircle,
  faPencilAlt,
  faSave,
  faEnvelope,
  faCarSide,
  faDollarSign,
  faInfoCircle,
  faShare,
  faUser,
  faPhone,
  faAt,
  faComment,
  faGasPump,
  faCalendar,
  faMobile,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faBars,
  faTrash,
  faEdit,
  faUniversity,
  faUserFriends,
  faFileInvoice,
  faCar,
  faHome,
  faList,
  faListAlt,
  faClipboardList,
  faSearch,
  faCalendarAlt,
  faMinus,
  faPlus,
  faWrench,
  faBook,
  faTimesCircle,
  faPencilAlt,
  faSave,
  faEnvelope,
  faCarSide,
  faDollarSign,
  faInfoCircle,
  faShare,
  faUser,
  faPhone,
  faAt,
  faComment,
  faGasPump,
  faCalendar,
  faMobile
);

ReactDOM.render(
  <UiContextProvider>
    <App />
  </UiContextProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
